import { useSelector } from "react-redux";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "../pages/onboarding/Login";
import ForgotPassword from "../pages/onboarding/ForgotPassword";
import OTP from "../pages/onboarding/OTP";
import NewPassword from "../pages/onboarding/NewPassword";
import Dashboard from "../pages/dashboard/dashboard";
import Layout from "../layout";
import AddUser from "../pages/dashboard/addUser";
import UserDetail from "../pages/dashboard/userDetail";
import Home from "../web/home";
import PrivateRoute from "./PrivateRoute";

const AppRoutes = () => {
  const { isLoggedIn, access_token } = useSelector((state) => state.auth);
  const isAuthenticated = isLoggedIn && !!access_token;

  return (
    <Routes>
      {/* Auth — already logged in toh dashboard pe */}
      <Route path="/" element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/otp" element={<OTP />} />
      <Route path="/set-password" element={<NewPassword />} />
      <Route path="/chat/:token" element={<Home />} />


      {/* Protected */}
      <Route path="/dashboard" element={<PrivateRoute><Layout><Dashboard /></Layout></PrivateRoute>} />
      <Route path="/dashboard/add-user" element={<PrivateRoute><Layout><AddUser /></Layout></PrivateRoute>} />
      <Route path="/dashboard/user-detail" element={<PrivateRoute><Layout><UserDetail /></Layout></PrivateRoute>} />

      {/* Koi bhi unknown route — login pe */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;
